// removed by extract-text-webpack-plugin
module.exports = {"container":"SingleRecordingView-container"};